import { render, staticRenderFns } from "./SparkLine.vue?vue&type=template&id=0cf2dad6&scoped=true&"
import script from "./SparkLine.vue?vue&type=script&lang=ts&"
export * from "./SparkLine.vue?vue&type=script&lang=ts&"
import style0 from "./SparkLine.vue?vue&type=style&index=0&id=0cf2dad6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2dad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VCard,VCardText,VDivider,VIcon,VSheet,VSparkline})
